module.exports = __webpack_public_path__ + "img/managementReport.f3748417.svg";